const enumEstiloCriticidade = {
  textoEstilo: "Alta",
  nomeIconeEstilo: "chevrons-up",
  tamanhoIconeEstilo: 16,
  estiloIcone: {
    color: "#ED1651"
  },
  estiloTexto: {
    border: "1px solid #DEE2E6",
    "border-radius": "4px",
    color: "#9E9E9E",
    background: "#FFFFFF",
    padding: "4px",
    width: "60px",
    "text-align": "center"
  }
};

export const enumNomeCriticidade = {
  ALTA: "ALTA",
  MEDIA: "MEDIA",
  BAIXA: "BAIXA"
};

export const enumCriticidade = {
  [enumNomeCriticidade.ALTA]: {
    ...enumEstiloCriticidade,
    textoEstilo: "Alta"
  },
  [enumNomeCriticidade.MEDIA]: {
    ...enumEstiloCriticidade,
    estiloIcone: {
      color: "#806604",
      transform: "rotate(90deg)"
    },
    textoEstilo: "Média"
  },
  [enumNomeCriticidade.BAIXA]: {
    ...enumEstiloCriticidade,
    estiloIcone: {
      color: "#00995D",
      transform: "rotate(180deg)"
    },
    textoEstilo: "Baixa"
  }
};
